export default "__VITE_ASSET__6uMnsgbT__"